module.exports = __webpack_public_path__ + "img/eas-head.c0d70a7c.svg";